import {Howl, Howler} from "howler";
import * as PIXI from "pixi.js";
import data from "./configs/data";
import {CustomSpineAnimation} from "./CustomSpineAnimation";
import {PixiApplication} from "./PixiApplication";
import {Utils} from "./Utils";

export class RouletteWheel extends PIXI.Container {

    private readonly ROULETTE_STATE_PREFIX = "win_";
    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);
    private readonly ROULETTES_STATE_KEYS = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k"];
    private readonly ROULETTE_FADE_ANIMATION_CONFIG = {
        NAME: "rouletteFade",
        STATES: {
            FADE_IN: "fadeIn",
            FADE_OUT: "fadeOut",
            IDLE: "idle",
        },
        SLOT_CONTAINERS: {
            MAIN: "main",
            BACKGROUND: "background",
        },
    };
    private rouletteWheels: Array<CustomSpineAnimation> = [];
    private rouletteFadeAnimation: CustomSpineAnimation;
    private wheelSpinSound: Howl;

    constructor() {
        super();
        this.createAndAddRouletteFadeAnimation();
        this.createAndAddBackgroundBlend();
        this.createAndAddRouletteAnimations();
        this.hideAllRouletteAnimations();
        this.rouletteWheels[0].visible = true;
        this.rouletteWheels[0].play("idle");
        this.wheelSpinSound = new Howl({
            src: [data.audios.wheelSpin],
        });
    }

    public async animateResult(targetNumber: number, quickSpin: boolean): Promise<any> {
        const drawnRouletteAnimation = Utils.getRandomInt(0, this.rouletteWheels.length - 1);
        const animationStateName = this.ROULETTE_STATE_PREFIX +
            this.ROULETTES_STATE_KEYS[drawnRouletteAnimation] + "_" + targetNumber;

        this.hideAllRouletteAnimations();
        this.rouletteWheels[drawnRouletteAnimation].visible = true;
        if (quickSpin) {
            this.rouletteFadeAnimation.play(this.ROULETTE_FADE_ANIMATION_CONFIG.STATES.FADE_IN);
            this.rouletteWheels[drawnRouletteAnimation].play(animationStateName, false, 5);
            await Utils.requestTimeout(3000);
            this.rouletteFadeAnimation.play(this.ROULETTE_FADE_ANIMATION_CONFIG.STATES.FADE_OUT);
        } else {
            this.rouletteFadeAnimation.play(this.ROULETTE_FADE_ANIMATION_CONFIG.STATES.IDLE);
            this.rouletteWheels[drawnRouletteAnimation].play(animationStateName);
            await Utils.requestTimeout(1200);
            this.wheelSpinSound.play();
            await Utils.requestTimeout(4200);
        }
    }

    private createAndAddRouletteFadeAnimation(): void {
        this.rouletteFadeAnimation = new CustomSpineAnimation(this.ROULETTE_FADE_ANIMATION_CONFIG.NAME);
        this.rouletteFadeAnimation.getSlotContainer(this.ROULETTE_FADE_ANIMATION_CONFIG.SLOT_CONTAINERS.MAIN,
            true);
        this.rouletteFadeAnimation.play(this.ROULETTE_FADE_ANIMATION_CONFIG.STATES.IDLE);
        this.addChild(this.rouletteFadeAnimation);
    }

    private createAndAddRouletteAnimations(): void {
        for (let i = 1; i <= 11; i++) {
            const rouletteWheel = new CustomSpineAnimation("rouletteWheel" + i);
            rouletteWheel.scale.y = -1;
            this.rouletteWheels.push(rouletteWheel);
            this.rouletteFadeAnimation.getSlotContainer(this.ROULETTE_FADE_ANIMATION_CONFIG.SLOT_CONTAINERS.MAIN)
                .addChild(rouletteWheel);
        }
    }

    private createAndAddBackgroundBlend(): void {
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0x000000, 0.7);
        graphics.drawRect(-PixiApplication.WIDTH, -PixiApplication.HEIGHT,
            PixiApplication.WIDTH * 2, PixiApplication.HEIGHT * 2);
        graphics.endFill();
        const backgroundBlend = new PIXI.Sprite(graphics.generateCanvasTexture());
        backgroundBlend.anchor = this.DEFAULT_ANCHOR_POINT;
        this.rouletteFadeAnimation.getSlotContainer(this.ROULETTE_FADE_ANIMATION_CONFIG.SLOT_CONTAINERS.BACKGROUND)
            .addChild(backgroundBlend);
    }

    private hideAllRouletteAnimations(): void {
        for (let i = 0; i < this.rouletteWheels.length; i++) {
            this.rouletteWheels[i].visible = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/RouletteWheel.ts